import React from 'react'
import _ from 'lodash'
import {Buffer} from 'buffer'

export const parsers = {
   hex: function(input) {
      const processed = input
         .split(/\s+/)
         .map(function(v) {
            return v ? ('0' + v).slice(-1 * v.length - v.length % 2) : ''
         })
         .join('')

      try {
         if (isNaN(parseInt(processed, 16)) || processed.match('x')) {
            return {error: 'invalid hex input'}
         }

         return new Buffer(processed, 'hex')
      } catch (e) {
         return {error: 'invalid hex input'}
      }
   },

   bytes: function(input) {
      let err

      const processed = input.split(/\s+/).reduce(function(acc, n) {
         if ('' === n) {
            return acc
         }

         const num = parseInt(n, 10)

         if (isNaN(num && !err)) {
            err = {error: 'invalid number `' + n + '` in byte array', pos: -1}
         } else if (255 < num || (0 > num && !err)) {
            err = {error: 'invalid byte `' + n + ', out of range 0..255', pos: -1}
         } else {
            acc.push(num)
         }

         return acc
      }, [])

      return err || new Buffer(processed)
   },

   ascii: function(input) {
      const processed = input
         .replace(/\\0/g, '\0')
         .replace(/\\\\/g, '\\')
         .replace(/\\a/g, '\a')
         .replace(/\\t/g, '\t')
         .replace(/\\n/g, '\n')
         .replace(/\\v/g, '\v')
         .replace(/\\f/g, '\f')
         .replace(/\\r/g, '\r')

      return new Buffer(processed)
   }
}

const parseAs = {
      '<':  parsers.hex,
      '[':  parsers.bytes,
      '"':  parsers.ascii,
      '\'': parsers.ascii
   },
   pairs = {
      '<':  '>',
      '[':  ']',
      '"':  '"',
      '\'': '\''
   }

// parse data as an output string
export const parse = function(input, currentPos, oldAcc) {
   let head, rest, parts, res,
      pos = currentPos || 0

   const acc = oldAcc || new Buffer('')

   if (!input) {
      return acc
   }

   let input2 = _.trimLeft(input)

   // preserve spaces for pos
   pos = pos + input.length - input2.length

   head = input2[0]
   rest = input2.slice(1)

   parts = rest.split(pairs[head])
   pos = pos + parts[0].length + 1

   if (undefined === parts[1] && pairs[head]) {
      return {error: 'expected a terminating `' + pairs[head] + '`', pos: pos + 1}
   }
   if (undefined === parts[1] && !pairs[head]) {
      return {
         error: 'expected your data to start with either: " .. ", [ ... ] or < ... >.',
         pos:   pos + 1
      }
   }

   res = parseAs[head](parts[0])
   parts.shift()

   rest = parts.join(pairs[head])

   return res.error ? res : parse(rest, pos + 1, Buffer.concat([acc, res]))
}

const formats = ['hex', 'bytes', 'ascii', 'ascii', 'decimals', 'raw']

const toNibble = c => ('0' + c.toString(16)).substr(-2)

const mapAscii = c => {
   switch (c) {
      case 7:
         return '\\a'
      case 8:
         return '\\b'
      case 9:
         return '\\t'
      case 10:
         return '\\n'
      case 11:
         return '\\v'
      case 12:
         return '\\f'
      case 13:
         return '\\r'
      default:
         return 32 > c || 177 <= c ? '\\0x' + toNibble(c) : String.fromCharCode(c)
   }
}

const toHex = buf => _.map(buf, toNibble).join(' ')
const toAscii = buf => _.map(buf, mapAscii).join('')
const toBase10 = buf => _.map(buf, n => n.toString(10)).join(' ')
const toBase64 = buf => buf.toString('base64')
const toRaw = buf => buf.toString('binary')

export const formatBuf = (buf, type) => {
   switch (type) {
      case 'hex':
         return toHex(buf)
      case 'ascii':
         return toAscii(buf)
      case 'decimals':
      case 'bytes':
         return toBase10(buf)
      case 'base64':
         return toBase64(buf)
      case 'raw':
      default:
         return toRaw(buf)
   }
}

export const formatters = {
   serial: function(line, fmt) {
      if (!line) {
         return null
      }

      if (-1 === formats.lastIndexOf(fmt)) {
         return {error: 'invalid output format `' + fmt + '`.'}
      }

      let encode = buf => formatBuf(new Buffer(buf, 'base64'), fmt)

      if (line.error) {
         let buf = '! Error: ' + line.error

         if (line.pos) {
            buf = buf + ' (char: ' + line.pos + ')'
         }

         return <span className="error"><br />{buf}</span>
      } else if (line['proto/tm']) {
         if ('serial' === line['proto/tm'].detail) {
            let evseq = ('000' + line['proto/tm'].packet_number.toString(16)).substr(-4),
               block = line['proto/tm'].block

            return (
               <span className={`upstream block-${block}`}>
                  <br /><b>recv</b> {evseq} &lt; {encode(line['proto/tm'].data)}
               </span>
            )
         } else if ('serial' === line['proto/tm'].command) {
            let cmdseq = ('0' + line['proto/tm'].cmd_number.toString(16)).substr(-2) + '  '

            return (
               <span className="downstream">
                  <br /><b>send</b> {cmdseq} &gt; {encode(line['proto/tm'].data)}
               </span>
            )
         } else if ('ack' === line['proto/tm'].detail) {
            let cmdseq = ('0' + line['proto/tm'].cmd_number.toString(16)).substr(-2),
               evseq = ('000' + line['proto/tm'].packet_number.toString(16)).substr(-4)

            return (
               <span className="meta">
                  <br /><b>recv</b> {evseq} / {cmdseq} ACK (router)
               </span>
            )
         } else {
            // random tinymesh line
            let cmdseq, evseq

            if (line['proto/tm'].cmd_number) {
               cmdseq = ('0' + line['proto/tm'].cmd_number.toString(16)).substr(-2)
            }

            if (line['proto/tm'].packet_number) {
               evseq = ('000' + line['proto/tm'].packet_number.toString(16)).substr(-4)
            }

            return (
               <span className="meta">
                  <br />
                  <b>{'event' === line['proto/tm'].type ? 'recv' : 'send'}</b>{' '}
                  {evseq || '    '}
                  {' '}
                  /
                  {' '}
                  {cmdseq || '  '}
                  {' '}
                  {line['proto/tm'].type}/{line['proto/tm'].detail || line['proto/tm'].command}
               </span>
            )
         }
      }

      if (Buffer.isBuffer(line)) {
         return <span className="meta">{line.toString()}</span>
      } else if (_.isString(line)) {
         return <span className="meta">{line}</span>
      } else {
         return (
            <span className="error"><b>INVALID: </b> <em>{JSON.stringify(line, null, 2)}</em></span>
         )
      }
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/console/parsing.js